export function calculatePreviewTextViewerCurrentPage({
  pageHeight,
  wrapperStartY,
  wrapperBottomY,
  currentScrollY,
  currentPageCount,
}: {
  pageHeight: number;
  wrapperStartY: number;
  wrapperBottomY: number;
  currentScrollY: number;
  currentPageCount: number;
}) {
  const roundedScrollY = Math.round(currentScrollY);
  if (roundedScrollY >= wrapperBottomY - pageHeight) {
    return currentPageCount;
  }

  return Math.max(
    Math.min(
      Math.floor((roundedScrollY + pageHeight - wrapperStartY) / pageHeight) +
        1,
      currentPageCount
    ),
    1
  );
}
